import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_3kr7fe4stt: FaireBrandEntity = {
  token: "b_3kr7fe4stt",
  type: "brand",
  name: "Seamhead Swag",
  avatarUrl:
    "https://cdn.faire.com/fastly/760b1c6f4b73644e2ea4662409f612fb2cf7db0ddfd2d291e8e512b1c0c17a3e.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/14323b80eb05e1053ae8517623152f59952e834773d96adeeb1d9962de4ddfdc.png",
  logoUrl:
    "https://cdn.faire.com/fastly/760b1c6f4b73644e2ea4662409f612fb2cf7db0ddfd2d291e8e512b1c0c17a3e.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/14323b80eb05e1053ae8517623152f59952e834773d96adeeb1d9962de4ddfdc.png",
  location: "Montgomery, AL, USA",
  minimumOrderDollars: 500,
  rating: 0,
  reviewCount: 0,
  isInsider: true,
  description:
    "Jerseys and apparel for baseball players, by baseball players. Seamhead Swag gives the baseball community the chance to rep the game we love with bold designs and loads of fun.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:15.912Z",
    importedBy: "entity-db-cli",
  },
};
